import { render, staticRenderFns } from "./MinhaConta.vue?vue&type=template&id=04392eb0&scoped=true&"
import script from "./MinhaConta.vue?vue&type=script&lang=js&"
export * from "./MinhaConta.vue?vue&type=script&lang=js&"
import style0 from "./MinhaConta.vue?vue&type=style&index=0&id=04392eb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04392eb0",
  null
  
)

export default component.exports